class MultistepStep extends HTMLElement {
  connectedCallback () {
    this.wizard = this.closest('multistep-wizard') || this.closest('multistep-wizard-captadores')

    this.addEventListener('valid', function (event) {
      this.valid = true
      if (event.detail.go) {
        this.next = event.detail.go
      }
      if (event.detail.auto) {
        this.goNext()
      }
    })
    this.addEventListener('invalid', function () {
      this.valid = false
    })
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.goNext()
      })
    }
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.goPrevious()
      })
    }
  }

  static get observedAttributes () {
    return ['valid']
  }

  // Only called for the "valid"attribute due to observedAttributes
  attributeChangedCallback (_name, _oldValue, newValue) {
    if (newValue === null) {
      this.hideNext()
    } else {
      this.showNext()
    }
  }

  show () {
    this.classList.add('shown')
    this._focus()

    if (this.isStart || (this.wizard?.omitingStart && this.isFirst)) return
  }

  _focus() {
    if (this.answers) {
      this.answers.dispatchEvent(new CustomEvent('show', { bubbles: true }))
    }
  }

  _blur() {
    if (this.answers) {
      this.answers.dispatchEvent(new CustomEvent('hide', { bubbles: true }))
    }
  }

  hide () {
    this.classList.remove('shown')
    this._blur()
  }

  goNext () {
    if (this.valid) {
      this.dispatchEvent(new CustomEvent('next', { bubbles: true }))
    }
  }

  goPrevious () {
    this.dispatchEvent(new CustomEvent('prev', { bubbles: true }))
  }

  showNext () {
    this.position !== 'start' && this.buttonDisabled.classList.add('hidden')
    this.nextButton.classList.remove('hidden')
  }

  hideNext () {
    this.nextButton.classList.add('hidden')
    this.position !== 'start' && this.buttonDisabled.classList.remove('hidden')
  }

  get answers () {
    return this.querySelector('multistep-answers')
  }

  get isStart () {
    return this.position === 'start'
  }

  get isFirst() {
    return this.wizard?.steps?.[0] === this
  }

  get next () {
    return this.getAttribute('go')
  }

  set next (newNext) {
    this.setAttribute('go', newNext)
  }

  get position () {
    return this.getAttribute('position')
  }

  get prev () {
    return this.getAttribute('prev')
  }

  set prev (newPrev) {
    this.setAttribute('prev', newPrev)
  }

  get nextButton () {
    return this.querySelector('[go=next]')
  }

  get prevButton () {
    return this.querySelector('[go=prev]')
  }

  get buttonDisabled () {
    return this.querySelector('.button-like-nav-disabled')
  }

  get valid() {
    return this.hasAttribute('valid')
  }

  set valid(value) {
    if (value) {
      this.setAttribute('valid', '')
    } else {
      this.removeAttribute('valid')
    }
  }
}

export default MultistepStep
